export enum LicensedModule {
  AUTOMATED_INDEXING = 'AUTOMATED_INDEXING',
  ORDER_ENTRY = 'ORDER_ENTRY',
  MAINTENANCE_PAYABLES = 'MAINTENANCE_PAYABLES',
  GENERAL_PAYABLES = 'GENERAL_PAYABLES',
}
